var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: bold;\n  color: ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: bold;\n  color: ', ';\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { primary } from '../../assets/colors';
import { PlayfairDisplay } from '../../assets/fonts';
var titleSizes = {
  sm: 24,
  md: 32,
  lg: 40
};
var TitleDefinition = styled.div(_templateObject, PlayfairDisplay, function (props) {
  return (titleSizes[props.size] || 24) + 'px';
}, primary);
TitleDefinition.displayName = 'Title';
TitleDefinition.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};
export default TitleDefinition;